'use client';

import { useEffect, useState } from 'react';
import { mutate } from 'swr';
import { sdk } from 'sdk';
import { useAccount } from 'frontastic';

export default function IdleLogout() {
  const IDLE_TIME = 72 * 60 * 60 * 1000;
  const { loggedIn, accountLoading } = useAccount();
  const [isModalOpen, setIsModalOpen] = useState(false);
  let idleTimeout: NodeJS.Timeout;

  const logout = async () => {
    if (loggedIn) {
      setIsModalOpen(true);
      const extensions = sdk.composableCommerce;
      await extensions.account.logout();
      mutate('/action/account/getAccount');
      mutate('/action/cart/getCart');
      mutate('/action/wishlist/getWishlist');
    }
  };

  const resetIdleTimer = () => {
    if (idleTimeout) clearTimeout(idleTimeout);
    idleTimeout = setTimeout(() => {
      logout();
    }, IDLE_TIME);
  };

  useEffect(() => {
    resetIdleTimer();

    const activityEvents = ['mousemove', 'keydown', 'scroll', 'click'];
    activityEvents.forEach((event) => window.addEventListener(event, resetIdleTimer));

    const handleOnline = () => console.log('You are back online');
    const handleOffline = () => {
      logout();
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      activityEvents.forEach((event) => window.removeEventListener(event, resetIdleTimer));
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      if (idleTimeout) clearTimeout(idleTimeout);
    };
  }, [accountLoading]);

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-20">
          <div className="rounded bg-white p-20 text-left shadow-lg">
            <p className="text-lg font-bold">Session Timeout</p>
            <p className="text-md my-20 font-medium">Session expired, login to continue.</p>
            <button
              type="button"
              className="mt-4 rounded-none bg-black px-8 py-8 text-white hover:bg-gray-500"
              onClick={() => setIsModalOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}
